import {Layout} from "./Layout.js";

export class BusinessSnsLayout extends Layout {
    template() {
        const {sectionId = '' } = this.$props;
        return `
            <section id="${sectionId}" class="signup-wide-pop  morningmate-type">
                    <header class="js-section-header"></header>
                    <article>
                        <div class="pop-main js-contents-main">
                            ${this.getMainTextTemplate()}
                            ${this.getSubTextTemplate()}
                            ${this.getNextLinkTemplate()}
                        </div>
                        <p class="bottom-text" style="text-align: center">
                          ${this.getPolicyBottomTemplate()}
                        </p>
                    </article>
                </section>`

    }
    getPolicyBottomTemplate() {
        if(Often.isGlobal()) {
            return super.getPolicyBottomTemplate()
        }
        return ''
    }
}